/* G3D custom (2026-10-08): Bundles hub redesign. Ported from the approved mockup (vault: Website/mockups/bundles-page-redesign.html, v11).
   Data (photos, names) comes from the JSON block sections/bundles-hub.liquid renders. */
(function () {
  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.querySelector('.g3d-bh'); if (!root) return;
  var DATA = JSON.parse(document.getElementById('bh-data').textContent);
  // the page's motion switch (WCAG 2.2.2): CSS pauses the animations, the timers below skip while STILL
  var STILL = root.classList.contains('bh-still'); // the section starts still (optimized theme)
  var motion = root.querySelector('.bh-motion');
  if (motion && !REDUCED) { // no button (an older section file): the page still runs, just without the switch
    motion.hidden = false;
    motion.onclick = function () {
      STILL = !STILL;
      root.classList.toggle('bh-still', STILL);
      motion.textContent = STILL ? 'Play motion' : 'Pause motion';
    };
  }
  function url(src) { return src; } // image URLs arrive ready-sized from Liquid
  function pickNot(list, used) {
    var free = list.filter(function (x) { return used.indexOf(x) < 0; });
    return free[Math.floor(Math.random() * free.length)];
  }
  // two stacked <img>: load the next into the hidden one, then crossfade
  function crossfade(box, src, done) {
    var imgs = box.querySelectorAll(':scope > img');
    var shown = imgs[0].classList.contains('bh-is-hidden') ? imgs[1] : imgs[0];
    var next = shown === imgs[0] ? imgs[1] : imgs[0];
    next.onload = function () { next.classList.remove('bh-is-hidden'); shown.classList.add('bh-is-hidden'); if (done) done(); };
    next.src = src;
  }
  function setFirst(box, src) { box.querySelector(':scope > img').src = src; }
  // is el near the screen? Timers below skip their work (and image downloads) while it isn't; first() runs the first time it is
  function seen(el, first) {
    var s = { on: !el || !('IntersectionObserver' in window) };
    if (s.on) { if (first) first(); return s; }
    new IntersectionObserver(function (e) { s.on = e[0].isIntersecting; if (s.on && first) { first(); first = null; } }, { root: matchMedia('(min-width: 990px)').matches ? document.querySelector('.page-wrapper') : null, rootMargin: '400px' }).observe(el); // Horizon scrolls .page-wrapper from 990px up; with the viewport as root it clips the margin away
    return s;
  }

  // Hero: three photos orbit the Poke Ball and swap designs
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  var HERO = shuffle(DATA.pool.reduce(function (a, p) { a.push([p[0].replace('width=300', 'width=360'), 0]); if (p[2]) a.push([p[2].replace('width=300', 'width=360'), 1]); return a; }, [])); // [image, isShiny]: the reel photos at the orbit's 360px
  var orbit = document.getElementById('orbit'), orbs = orbit.querySelectorAll('.bh-orb'), heroShown = [];
  orbs.forEach(function (o, i) {
    var h = HERO[i]; heroShown.push(h);
    if (!h) return; // fewer photos than orbs: this orb stays hidden
    o.querySelector(':scope > img').onload = function () { o.classList.add('bh-is-ready'); };
    setFirst(o, h[0]); o.classList.toggle('bh-is-shiny', !!h[1]);
  });
  var T0 = performance.now(), prev = T0, heroSeen = seen(orbit), placed = false, size, d;
  function measure() { size = orbit.clientWidth; d = orbs[0].clientWidth; placed = false; if (REDUCED) place(prev); } // read on resize only: reading them every frame forced a layout each frame; then re-place the photos (reduced motion has no frame loop)
  measure(); if (window.ResizeObserver) new ResizeObserver(measure).observe(orbit);
  function place(t) {
    if (STILL) T0 += t - prev; // paused: hold the angle so the photos resume where they stopped
    prev = t;
    if (placed && (STILL || !heroSeen.on)) { if (!REDUCED) requestAnimationFrame(place); return; }
    placed = true; // the first frame always places the photos, before we know whether the hero is on screen
    var r = size * 0.38;
    var a = ((t - T0) / 70000) * Math.PI * 2; // one lap every 70 s
    orbs.forEach(function (o, i) {
      var ang = a + i * (Math.PI * 2 / 3) - Math.PI / 2;
      o.style.transform = 'translate(' + (size / 2 + Math.cos(ang) * r - d / 2) + 'px,' + (size / 2 + Math.sin(ang) * r - d / 2) + 'px)';
    });
    if (!REDUCED) requestAnimationFrame(place);
  }
  place(T0);
  if (!REDUCED) {
    var hk = 0;
    setInterval(function () {
      if (STILL || !heroSeen.on) return;
      var i = hk++ % 3, h = pickNot(HERO, heroShown);
      if (!h) return; // every photo is already on the ring
      heroShown[i] = h;
      crossfade(orbs[i], h[0], function () { orbs[i].classList.toggle('bh-is-shiny', !!h[1]); });
    }, 2600);
  }

  // Countdown on the limited-time banner (rendered only while it is switched on and running)
  var cd = document.getElementById('countdown');
  if (cd) {
  var END = Date.parse(cd.dataset.end);
  function tick() {
    var s = Math.max(0, Math.floor((END - Date.now()) / 1000));
    cd.querySelector('[data-d]').textContent = Math.floor(s / 86400);
    cd.querySelector('[data-h]').textContent = String(Math.floor(s % 86400 / 3600)).padStart(2, '0');
    cd.querySelector('[data-m]').textContent = String(Math.floor(s % 3600 / 60)).padStart(2, '0');
    cd.querySelector('[data-s]').textContent = String(s % 60).padStart(2, '0');
  }
  tick(); setInterval(tick, 1000);
  }

  // Build your own: slot-machine reels
  var POOL = shuffle(DATA.pool); // [image, name, shiny image]
  if (POOL.length > 3) { // with 3 designs or fewer the reels can't change, so Liquid's first frame stays
  var reelSeen = seen(document.querySelector('.bh-machine'), !REDUCED && function () { // preload so reels never show blanks, once they're near (still reels never change)
    POOL.forEach(function (p) { new Image().src = url(p[0]); if (p[2]) new Image().src = url(p[2]); });
  });
  var k = POOL.findIndex(function (p) { return p[2]; }); if (k > -1) { var t = POOL[1]; POOL[1] = POOL[k]; POOL[k] = t; } // a shiny design in the middle reel, without repeating reel 1 or 3
  var picks = document.querySelectorAll('.bh-pick'), save = document.querySelector('.bh-save'), current = POOL.slice(0, 3);
  function cell(src) { var im = document.createElement('img'); im.alt = ''; im.src = src; return im; }
  function show(pick, p, shiny) {
    var reel = pick.querySelector('.bh-reel'); reel.innerHTML = ''; reel.appendChild(cell(url(shiny ? p[2] : p[0])));
    pick.querySelector('.bh-slot').classList.toggle('bh-is-shiny', !!shiny);
    pick.querySelector('.bh-pick__name').textContent = (shiny ? '✦ Shiny ' : '') + p[1];
  }
  picks.forEach(function (pk, i) { show(pk, current[i], i === 1 && !!current[i][2]); });
  function spin(pick, idx, delay, done) {
    var used = current.slice(), target = pickNot(POOL, used), shiny = !!target[2] && Math.random() < .5;
    current[idx] = target;
    var reel = pick.querySelector('.bh-reel'), slot = pick.querySelector('.bh-slot'), name = pick.querySelector('.bh-pick__name');
    var h = slot.clientHeight, steps = 4 + idx; // later reels spin a little longer
    for (var s = 0; s < steps - 1; s++) reel.appendChild(cell(url(POOL[Math.floor(Math.random() * POOL.length)][0])));
    reel.appendChild(cell(url(shiny ? target[2] : target[0])));
    var ms = 820 + idx * 160;
    reel.style.setProperty('--spin-ms', ms + 'ms');
    setTimeout(function () {
      name.classList.add('bh-is-hidden');
      slot.classList.remove('bh-is-shiny', 'bh-is-landed');
      reel.classList.add('bh-is-spinning');
      reel.style.transition = 'transform ' + ms + 'ms cubic-bezier(.15,.85,.25,1.08)';
      reel.style.transform = 'translateY(' + (-h * steps) + 'px)';
      setTimeout(function () {
        reel.classList.remove('bh-is-spinning');
        reel.style.transition = 'none'; reel.style.transform = 'translateY(0)';
        show(pick, target, shiny);
        void slot.offsetWidth; slot.classList.add('bh-is-landed');
        name.classList.remove('bh-is-hidden');
        if (done) done();
      }, ms + 30);
    }, delay);
  }
  if (!REDUCED) {
    setInterval(function () {
      if (STILL || !reelSeen.on) return;
      spin(picks[0], 0, 0); spin(picks[1], 1, 120);
      spin(picks[2], 2, 240, function () { save.classList.remove('bh-is-pop'); void save.offsetWidth; save.classList.add('bh-is-pop'); });
    }, 3800);
  }
  }

  // Curated trios: cycle through real sets
  document.querySelectorAll('.bh-trio').forEach(function (trio, t) {
    var sets = JSON.parse(trio.dataset.sets), discs = trio.querySelectorAll('.bh-disc'), label = trio.parentNode.querySelector('.bh-bcard__set'), k = 0;
    if (!sets.length) return;
    function apply(first) {
      var s = sets[k % sets.length];
      discs.forEach(function (d, i) { first ? setFirst(d, url(s[i + 1], 300)) : setTimeout(function () { crossfade(d, url(s[i + 1], 300)); }, i * 140); });
      label.classList.add('bh-is-hidden');
      setTimeout(function () { label.textContent = 'Shown: ' + s[0]; label.classList.remove('bh-is-hidden'); }, first ? 0 : 350);
    }
    apply(true);
    var trioSeen = seen(trio, !REDUCED && function () { sets.forEach(function (s) { s.slice(1).forEach(function (f) { new Image().src = url(f, 300); }); }); }); // preload the other sets once the card is near
    if (!REDUCED) setTimeout(function () { setInterval(function () { if (trioSeen.on && !STILL) { k++; apply(false); } }, 4200); }, t * 2100);
  });

  // Eeveelution ring
  document.querySelectorAll('.bh-ring').forEach(function (ring) { // evolutions are placed evenly around the centre ball
    var imgs = ring.querySelectorAll('img:not(.bh-center)');
    imgs.forEach(function (img, i) {
      var a = (i / imgs.length) * Math.PI * 2 - Math.PI / 2;
      img.style.setProperty('--x', Math.cos(a).toFixed(3));
      img.style.setProperty('--y', Math.sin(a).toFixed(3));
    });
  });
})();

// G3D custom (2026-10-11): Bundles page backdrop (type-mark tile, ball trails, zodiac, twinkling stars)
(function () {
if (!document.getElementById('bh-bgMarks')) return; // no backdrop on this page
const TYPE_C = { Normal: '#9c9c8a', Fire: '#f06a24', Water: '#2f8fe0', Grass: '#3fa34d', Electric: '#f2c318', Ice: '#5fc7e3', Fighting: '#c43d2b',
  Poison: '#9b4fc4', Ground: '#cf9550', Flying: '#7f9cec', Psychic: '#ee4f86', Bug: '#93ad1e', Rock: '#ad995b', Ghost: '#6a54a6', Dragon: '#5661e0',
  Dark: '#4f4654', Steel: '#6b97ab', Fairy: '#e88bda' };
const ICON = {
  Normal: '!M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 5a4 4 0 1 1 0 8 4 4 0 0 1 0-8z',
  Fire: 'M12 2c1 4 6 6 6 12a6 6 0 0 1-12 0c0-3 2-5 3-6 0 2 1 3 2 3 0-4-1-6 1-9z',
  Water: 'M12 2s7 8 7 13a7 7 0 0 1-14 0c0-5 7-13 7-13z',
  Grass: 'M20 4C9 4 4 10 4 17c0 1 .1 2 .3 3C6 13 11 9 16 8c-5 3-8 7-9.5 12.5.8.3 1.7.5 2.5.5C17 21 20 13 20 4z',
  Electric: 'M14 2 4 14h6.5L9 22l11-13h-7z',
  Ice: 'M10.8 2h2.4v20h-2.4zM3.94 5.96l17.32 10-1.2 2.08-17.32-10zM2.74 15.96l17.32-10 1.2 2.08-17.32 10z',
  Fighting: '!M5 10a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v3a8 8 0 0 1-8 8h-1a6 6 0 0 1-6-6zM9.2 7v4h1.4V7zm4.2 0v4h1.4V7z',
  Poison: 'M12 2a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM6.5 15.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM17 16a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z',
  Ground: 'M3 12h18v3.2H3zM5.5 17h13v3.2h-13zM12 3l7 7H5z',
  Flying: 'M2 14c6 1 11-2 20-10-1 9-6 15-13 15-3 0-5-2-7-5z',
  Psychic: '!M12 5C6 5 2 12 2 12s4 7 10 7 10-7 10-7-4-7-10-7zm0 3.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z',
  Bug: 'M12 7.5c3.3 0 5.5 3.2 5.5 6.8S15.3 21 12 21s-5.5-3.1-5.5-6.7S8.7 7.5 12 7.5zM8.6 2.6l1.3-.7 2 3.4-1.3.7zM15.4 2.6l-1.3-.7-2 3.4 1.3.7z',
  Rock: 'M4 19 5.5 9.5 11 5l7 2 3 7.5L18 19z',
  Ghost: '!M5 21V11a7 7 0 0 1 14 0v10l-2.33-2-2.34 2L12 19l-2.33 2-2.34-2zM8.8 10h2.2v3H8.8zm4.2 0h2.2v3H13z',
  Dragon: 'M5 21c0-9 5-16 15-18-4 3-6 7-6 11 0 4-3 7-9 7z',
  Dark: 'M14.5 3a9 9 0 1 0 6.5 15.2A8 8 0 0 1 14.5 3z',
  Steel: '!M12 2l8.66 5v10L12 22l-8.66-5V7zm0 6.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z',
  Fairy: 'M12 2c.9 5.6 4.4 9.1 10 10-5.6.9-9.1 4.4-10 10-.9-5.6-4.4-9.1-10-10 5.6-.9 9.1-4.4 10-10z'
};
// backdrop: a 720px tile = 4 copies of the 18 type marks bundled into 6 trios (a faint dotted triangle ties each trio), with + and ✦
// in between. A few trios are joined into constellations through little extra stars, which also hides the grid.
const TRIOS = [['Fire', 'Water', 'Grass'], ['Electric', 'Ice', 'Flying'], ['Psychic', 'Fighting', 'Dark'], ['Rock', 'Ground', 'Steel'], ['Ghost', 'Poison', 'Bug'], ['Dragon', 'Fairy', 'Normal']];
const AT = [[60, 60], [190, 125], [305, 50], [75, 235], [205, 300], [310, 215]];
const Q = [[0, 0], [360, 0], [0, 360], [360, 360]];
const corner = (q, k, i) => { const a = (k * 37 + i * 120 - 90) * Math.PI / 180; return [Q[q][0] + AT[k][0] + 22 * Math.cos(a), Q[q][1] + AT[k][1] + 22 * Math.sin(a)]; };
// constellations, as polylines: [quadrant, trio, corner] = a trio's mark, [x, y] = an extra star
const LINKS = [
  [[104, 96], [146, 108], [142, 150], [98, 138], [104, 96]], [[0, 0, 1], [104, 96]], [[146, 108], [0, 1, 2]], [[98, 138], [70, 168], [0, 3, 2]], // dipper: bowl, handle, tail
  [[1, 1, 0], [585, 70], [606, 112], [628, 80], [646, 128], [1, 5, 1]], // a W
  [[1, 5, 0], [650, 270], [676, 298], [657, 330], [692, 358], [3, 2, 0]], // a long zigzag down into the next quadrant
  [[2, 3, 0], [118, 636], [130, 615], [156, 628], [150, 672], [2, 4, 1]], [[156, 628], [176, 600], [168, 574]],
  [[3, 0, 2], [392, 470], [418, 492], [410, 530], [436, 548], [3, 3, 2]], [[418, 492], [452, 478], [470, 502]],
  [[1, 3, 0], [470, 282], [498, 296], [515, 272], [1, 4, 1]], [[470, 282], [462, 318], [484, 340]]];
const pt = p => (p.length === 3 ? corner(...p) : p).map(n => n.toFixed(1)).join(' ');
const mark = (fill, d, x, y, s, rot) => `<path fill="${fill}"${d[0] === '!' ? ' fill-rule="evenodd"' : ''} transform="translate(${x} ${y}) rotate(${rot}) scale(${s}) translate(-12 -12)" d="${d.replace('!', '')}"/>`;
const tile = '<svg xmlns="http://www.w3.org/2000/svg" width="720" height="720"><g fill="none" stroke="#a78bfa" stroke-width="2.4" stroke-linejoin="round">' +
  LINKS.map(l => `<path d="M${l.map(pt).join('L')}"/>`).join('') + '</g><g fill="#a78bfa">' +
  LINKS.flat().filter(p => p.length === 2).map(([x, y]) => `<circle cx="${x}" cy="${y}" r="${2.9 + (x * 7 + y * 3) % 5 * .5}"/>`).join('') + // stars of a few sizes
  '</g><g fill="none" stroke="#8b8b99" stroke-width="2.2" stroke-dasharray="3 6" stroke-linecap="round">' +
  Q.map((o, q) => TRIOS.map((t, k) => `<path d="M${[0, 1, 2].map(i => pt([q, k, i])).join('L')}Z"/>`).join('')).join('') + '</g>' +
  Q.map(([ox, oy], q) => TRIOS.map((trio, k) =>
    trio.map((t, i) => { const [x, y] = corner(q, k, i); return mark(TYPE_C[t], ICON[t], x.toFixed(1), y.toFixed(1), .85, (k * 47 + i * 29) % 50 - 25); }).join('')).join('') +
    [[128, 190], [250, 40], [20, 150]].map(([x, y]) => mark('#8b5cf6', 'M10 4h4v6h6v4h-6v6h-4v-6H4v-4h6z', x + ox, y + oy, .6, 0)).join('') +
    [[130, 20], [255, 240], [130, 255]].map(([x, y]) => mark('#f2b705', ICON.Fairy, x + ox, y + oy, .5, 0)).join('')).join('') + '</svg>';
document.getElementById('bh-bgMarks').style.backgroundImage = `url("data:image/svg+xml,${encodeURIComponent(tile)}")`;
// a dotted trail behind each riding ball, in its colour (both rings turn anticlockwise, so "behind" is the clockwise side):
// orbit radius, [ball angle, colour], first-dot offset and spacing in degrees, first-dot size
const trail = (id, R, balls, a1, da, r0) => { document.getElementById(id).innerHTML = balls.map(([a0, c]) => [1, 2, 3, 4, 5, 6].map(k => {
  const a = (a0 + a1 + k * da) * Math.PI / 180;
  return `<circle cx="${(R * Math.cos(a)).toFixed(1)}" cy="${(R * Math.sin(a)).toFixed(1)}" r="${(r0 * (1 - k * .115)).toFixed(2)}" fill="${c}" opacity="${(.55 - k * .07).toFixed(2)}"/>`;
}).join('')).join(''); };
trail('bh-bgTrails', 92, [[0, '#22c55e'], [120, '#3b82f6'], [240, '#facc15']], 9, 5, 1.9); // Dusk, Beast, Quick
trail('bh-bgTrails3', 92, [[0, '#facc15'], [180, '#dc2626']], 11, 5, 2.2); // Ultra, Luxury (top right)
trail('bh-bgTrails4', 60, [[0, '#ef4444'], [120, '#2563eb'], [240, '#8e4fd8']], 13, 6, 1.6); // Cherish, Great, Clone (top right)
// orrery dial: the 18 type marks round it like a zodiac, each turned to face outwards
document.getElementById('bh-bgZodiac').innerHTML = Object.keys(TYPE_C).map((t, k) => {
  const a = k * 20 - 90, r = a * Math.PI / 180;
  return mark(TYPE_C[t], ICON[t], (55 * Math.cos(r)).toFixed(1), (55 * Math.sin(r)).toFixed(1), .24, a + 90);
}).join('');
// twinkling stars (dark mode only, see CSS): one small tile per layer, in three sizes so the layers never line up;
// white dots with a faint halo, plus one little gold or violet sparkle per tile
document.querySelectorAll('.bh-bg__stars').forEach((el, n) => {
  const size = [260, 340, 410][n]; let seed = 7 + n * 101; const rnd = () => (seed = seed * 16807 % 2147483647) / 2147483647;
  const star = i => {
    const x = (6 + rnd() * (size - 12)).toFixed(0), y = (6 + rnd() * (size - 12)).toFixed(0), r = .6 + rnd() * 1.1;
    return i ? `<circle cx="${x}" cy="${y}" r="${(r * 2.6).toFixed(2)}" fill="#fff" opacity=".12"/><circle cx="${x}" cy="${y}" r="${r.toFixed(2)}" fill="#fff"/>`
      : mark(n % 2 ? '#c4b5fd' : '#ffe9a8', ICON.Fairy, x, y, .32, 0);
  };
  el.style.background = `url("data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">${[0, 1, 2, 3, 4].map(star).join('')}</svg>`)}") 0 0 / ${size}px ${size}px`;
});
})();
